import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import DailySalesReportAPI from "../../../api/DailySalesReportAPI";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import ChartComponent from "../FixedReportChart";

class CallFeedbackReport extends React.Component {
  constructor(props) {
    super(props);
    this.user = reactLocalStorage.getObject(Constants.Model).user.options;
    // Get feedback options from local storage
    const feedbackOptions = reactLocalStorage.getObject(Constants.Model).call.fields.feedback.options;
    this.state = {
      feedbackData: [],
      feedbackOptions,
      userNames: [],
      feedbackSumsByUser: {},
      feedbackSumsTotal: {},
      inApiCall: true,
    };
  }

  componentDidMount() {
    // Fetch call feedback data
    DailySalesReportAPI.getCallfeedback(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }
  handleReceivedData = (data) => {
    // Prepare the sums for each feedback per user
    const userNames = this.props.filters.selectedIds.map((id) => {
      return this.user.find(user => parseInt(user.value) === parseInt(id)).name;
    });

    const feedbackSumsByUser = {};
    const feedbackSumsTotal = {}; // New object to store totals for each feedback type

    data.forEach(({ feedback, sum, responsible_person }) => {
      const userName = this.user.find(user => parseInt(user.value) === parseInt(responsible_person)).name;
      // Initialize sums for each user if not already present
      if (!feedbackSumsByUser[userName]) {
        feedbackSumsByUser[userName] = this.state.feedbackOptions.reduce((acc, option) => {
          acc[option.label] = 0;
          return acc;
        }, {});
      }
      // Increment the sum for the appropriate feedback and user
      const feedbackLabel = this.state.feedbackOptions.find(option => option.value === feedback)?.label;
      if (feedbackLabel) {
        feedbackSumsByUser[userName][feedbackLabel] += sum;
        
        // Also increment the total sum for this feedback type
        if (!feedbackSumsTotal[feedback]) {
          feedbackSumsTotal[feedback] = 0;
        }
        feedbackSumsTotal[feedback] += sum;
      }
    });

    this.setState({
      feedbackData: data,
      inApiCall: false,
      userNames,
      feedbackSumsByUser,
      feedbackSumsTotal, // Store the total feedback sums
    });
  };

  handleFail = () => {
    this.setState({ inApiCall: false });
  };

  render() {
    const { feedbackData, feedbackOptions,userNames, feedbackSumsByUser, feedbackSumsTotal,  inApiCall } = this.state;
    // Create a dictionary to map feedback values to sums
    const feedbackSums = feedbackOptions.reduce((acc, option) => {
      acc[option.value] = 0;
      return acc;
    }, {});

    feedbackData.forEach(item => {
      if (feedbackSums.hasOwnProperty(item.feedback)) {
        feedbackSums[item.feedback] += item.sum;
      }
    });

    return (
    <ApiUiController inApiCall={inApiCall}>
      <div>
        <h2>Call Feedback Report</h2>
        <hr />
        <div className="row">
      <Table striped bordered hover className="col-md-6">
        <thead>
          <tr>
            <th>Feedback</th>
            {userNames.map((userName, index) => (
              <th key={index}>{userName}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {feedbackOptions.map(({ label }, index) => (
            <tr key={index}>
              <td>{label}</td>
              {userNames.map((userName) => (
                <td key={userName}>
                  {feedbackSumsByUser[userName] ? feedbackSumsByUser[userName][label] : 0}
                </td>
              ))}
            </tr>
          ))}
            <tr>
              <th>Total</th>
              {
                userNames.map((userName) => (
                  feedbackSumsByUser[userName] ? 
                    <th>{Object.values(feedbackSumsByUser[userName]).reduce((acc,current)=>acc+=current,0)} </th> : <th>0</th>
                ))
              }
            </tr>
        </tbody>
      </Table>
      <div className="col-md-6">
        {/* Add Chart Component */}
       <ChartComponent progressSums={feedbackSumsTotal} progressOptions={feedbackOptions} type="bar" />
      </div>
    </div>
  </div>
    </ApiUiController>
      );
    }
}

export default withRouter(CallFeedbackReport);
